<template>
  <v-container pt-0 fluid>
    <v-layout>
      <v-flex xs12 v-show="$apollo.loading">
        <v-layout justify-center>
          <v-progress-circular
            indeterminate
            :size="50"
            color="primary"
          ></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-slide-y-transition>
        <v-flex xs12 raised v-show="!$apollo.loading">
          <v-row justify="end">
            <itinerary-details-settings
              :visible-tabs="tabs"
              @change="onSettingsChange"
            ></itinerary-details-settings>
          </v-row>
          <v-tabs fixed-tabs v-model="selectedTab" show-arrows>
            <template v-if="tabIsVisible('items') && showItemsTabFirst">
              <v-tab key="items" ripple>Items</v-tab>
              <v-tab-item key="items" class="bg">
                <v-row>
                  <itinerary-details-items-list
                    :itinerary="itinerary"
                  ></itinerary-details-items-list>
                </v-row>
              </v-tab-item>
            </template>
            <template v-if="tabIsVisible('details')">
              <v-tab key="details" ripple>Details</v-tab>
              <v-tab-item key="details" class="bg">
                <v-row>
                  <basic-components-list
                    :list="boxes"
                    :data="itinerary"
                    :visibleItems="boxesSettings.visibleItems"
                    :columns="boxesSettings.columns"
                    @change="onBoxesSettingsChange"
                  ></basic-components-list>
                </v-row>
                <v-row>
                  <basic-components-list
                    :list="charts"
                    :data="itinerary"
                    :visibleItems="chartsSettings.visibleItems"
                    :columns="chartsSettings.columns"
                    @change="onChartsSettingsChange"
                  ></basic-components-list>
                </v-row>
              </v-tab-item>
            </template>
            <template v-if="tabIsVisible('items') && !showItemsTabFirst">
              <v-tab key="items" ripple>Items</v-tab>
              <v-tab-item key="items" class="bg">
                <v-row>
                  <itinerary-details-items-list
                    :itinerary="itinerary"
                  ></itinerary-details-items-list>
                </v-row>
              </v-tab-item>
            </template>
            <template v-if="tabIsVisible('participants')">
              <v-tab key="participants" ripple>Participants</v-tab>
              <v-tab-item key="participants" class="pt-2 bg">
                <itinerary-details-participants-list
                  :participants="itinerary.participants.edges"
                ></itinerary-details-participants-list>
              </v-tab-item>
            </template>
            <template v-if="tabIsVisible('documents')">
              <v-tab key="documents" ripple>Documents</v-tab>
              <v-tab-item key="documents" class="bg">
                <v-row>
                  <itinerary-details-documents-list
                    @contact-client="onContactClient"
                    @contact-agent="onContactAgent"
                    @contact-supplier="onContactSupplier"
                    @form-details="onFormDetails"
                    :itinerary="itinerary"
                  ></itinerary-details-documents-list>
                </v-row>
              </v-tab-item>
            </template>
            <template v-if="tabIsVisible('vouchers')">
              <v-tab key="vouchers" ripple>Vouchers</v-tab>
              <v-tab-item key="vouchers" class="pt-2 bg">
                <itinerary-details-vouchers :itinerary="itinerary" />
              </v-tab-item>
            </template>
            <template v-if="tabIsVisible('finances')">
              <v-tab key="finances" @click="salesInvoiceSkip = false" ripple
                >Finances</v-tab
              >
              <v-tab-item key="finances" class="pt-2 bg">
                <itinerary-details-finances-tabs
                  :itinerary="itinerary"
                  :customFilters="customFilters"
                  @onMessage="onMessage"
                ></itinerary-details-finances-tabs>
              </v-tab-item>
            </template>
            <template
              v-if="
                tabIsVisible('routes') &&
                this.$store.getters.hasAccessTo('itineraries:routes', true)
              "
            >
              <v-tab key="routes" ripple>Routes</v-tab>
              <v-tab-item key="routes" class="pt-2 bg">
                <itinerary-routes
                  :itinerary-id="id"
                  v-model="routes"
                  :itinerary="itinerary"
                />
              </v-tab-item>
            </template>
            <template v-if="tabIsVisible('contents')">
              <v-tab key="contents" ripple>Notes & Contents</v-tab>
              <v-tab-item key="contents" class="pt-2 bg">
                <contents
                  :owner-id="id"
                  owner-name="ITINERARY"
                  :set-default-lang="false"
                ></contents>
              </v-tab-item>
            </template>
            <template
              v-if="
                tabIsVisible('scenarios') &&
                this.$store.getters.hasAccessTo(
                  'itineraries:service_groups',
                  true
                )
              "
            >
              <v-tab key="scenarios" ripple>Service Groups</v-tab>
              <v-tab-item key="scenarios" class="pt-2 bg">
                <service-groups
                  :items="items"
                  :itinerary-participants="participants"
                  v-model="serviceGroups"
                  @save="onServiceGroupsSave"
                  :itinerary="itinerary"
                ></service-groups>
              </v-tab-item>
            </template>
            <template v-if="tabIsVisible('logs')">
              <v-tab key="logs" ripple>Logs</v-tab>
              <v-tab-item key="logs" class="pt-2 bg">
                <itinerary-details-logs
                  v-model="logs"
                  :itinerary="itinerary"
                  @reload="reloadItinerary"
                ></itinerary-details-logs>
              </v-tab-item>
            </template>

            <template
              v-if="
                tabIsVisible('tasks') &&
                this.$store.getters.hasAccessTo('plugins:task_tracker')
              "
            >
              <v-tab key="tasks" ripple>Tasks</v-tab>
              <v-tab-item key="tasks" class="pt-2 bg">
                <task-tracker-list :itinerary="itinerary"></task-tracker-list>
              </v-tab-item>
            </template>
            <template
              v-if="
                tabIsVisible('increments') &&
                this.$store.getters.hasAccessTo('itineraries:increments', true)
              "
            >
              <v-tab key="increments" ripple>Increments</v-tab>
              <v-tab-item key="increments" class="pt-2 bg">
                <itinerary-increments
                  :itinerary="itinerary"
                ></itinerary-increments>
              </v-tab-item>
            </template>
            <template v-if="tabIsVisible('emails')">
              <v-tab key="emails" ripple>Emails</v-tab>
              <v-tab-item key="emails" class="pt-2 bg">
                <emails-list :itineraryId="id" />
              </v-tab-item>
            </template>
            <template
              v-if="
                tabIsVisible('pushNotifications') &&
                this.$store.getters.hasAccessTo(
                  'itineraries:push_notifications',
                  true
                )
              "
            >
              <v-tab key="pushNotifications" ripple>Push Notifications</v-tab>
              <v-tab-item key="pushNotifications" class="pt-2 bg">
                <itinerary-push-notifications :itinerary-id="id" />
              </v-tab-item>
            </template>
            <template
              v-if="
                tabIsVisible('roomingList') &&
                this.$store.getters.hasAccessTo('itineraries:rooming_list')
              "
            >
              <v-tab key="roomingList" ripple>Rooming List</v-tab>
              <v-tab-item key="roomingList" class="pt-2 bg">
                <rooming-list :itinerary="itinerary" />
              </v-tab-item>
            </template>
            <template v-if="tabIsVisible('customDataTypes')">
              <v-tab key="customDataTypes" ripple>Custom Data</v-tab>
              <v-tab-item key="customDataTypes" class="pt-2 bg">
                <custom-data-types owner="ITINERARY" :owner-id="itinerary.id" />
              </v-tab-item>
            </template>
            <v-tab @click="onEdit">
              <v-icon small left>mdi-pencil</v-icon>
              Edit
            </v-tab>
            <v-menu bottom left v-if="false">
              <template v-slot:activator="{ on }">
                <v-btn text class="align-self-center mr-4" v-on="on">
                  more
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="onEdit">
                  <v-list-item-icon>
                    <v-icon small>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title> Edit</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-row align="center">
              <itinerary-details-contact-suppliers
                :itinerary-id="id"
                @contact-client="onContactClient"
                @contact-agent="onContactAgent"
                @contact-supplier="onContactSupplier"
                @form-details="onFormDetails"
              ></itinerary-details-contact-suppliers>
            </v-row>
          </v-tabs>
          <v-container fluid v-if="selectedTab == 0">
            <v-row justify="center">
              <v-btn text @click="onEdit" class="mr-2">
                <v-icon left small>mdi-pencil</v-icon>Edit
              </v-btn>
              <itinerary-details-contact-suppliers
                :itinerary-id="id"
                @contact-client="onContactClient"
                @contact-agent="onContactAgent"
                @contact-supplier="onContactSupplier"
                @form-details="onFormDetails"
              ></itinerary-details-contact-suppliers>
              <back-to-list-btn route="/itineraries"></back-to-list-btn>
            </v-row>
          </v-container>
        </v-flex>
      </v-slide-y-transition>
    </v-layout>
    <email-dialog
      :show="showEmailDialog"
      v-model="email"
      @close="showEmailDialog = false"
      @send="onSendMessage"
      :key="emailDialogKey"
      :itinerary="itinerary"
    ></email-dialog>
    <external-form-dialog
      :show="showFormDetails"
      v-model="selectedForm"
      :itinerary="itinerary"
      @close="showFormDetails = false"
    />
    <div v-if="debug">
      <code>{{ selectedTab }}</code>
      <code>{{ this.id }}</code>
    </div>
  </v-container>
</template>
<script>
import {
  ITINERARY_RECORD,
  UPDATE_ITI_HEADER,
  SEND_CLIENT_MESSAGE,
} from "../../../constants/graphql";
import ItineraryDetailsHeaderInfo from "./ItineraryDetailsHeaderInfo";
import ItineraryDetailsItemsList from "./ItineraryDetailsItemsList";
import ItineraryDetailsParticipantsList from "./ItineraryDetailsParticipantsList";
import ItineraryDetailsDocumentsList from "./ItineraryDetailsDocumentsList";
import ItineraryDetailsFinancesTabs from "./ItineraryDetailsFinancesTabs";
import SalesInvoiceList from "../finances/sales-invoices/SalesInvoiceList";
import PaymentList from "../finances/payments/PaymentList";
import PurchaseInvoiceList from "../finances/purchase-invoices/PurchaseInvoiceList";
import ItineraryDetailsContactSuppliers from "./contact-suppliers/ItineraryDetailsContactSuppliers";
import BackToListBtn from "../shared/BackToListBtn";
import ItineraryRoutes from "./routes/ItineraryRoutes";
import BasicComponentsList from "../shared/BasicComponentsList";
import { removeGQLTypename, sortBy } from "../../../helpers/index";
import boxes from "./details-boxes-list.js";
import charts from "./details-charts/index";
import ItineraryDetailsSettings from "./ItineraryDetailsSettings";
import Contents from "../shared/contents/Contents";
import ServiceGroups from "./scenarios/ServiceGroups";
import ItineraryDetailsLogs from "./ItineraryDetailsLogs";
import EmailDialog from "../shared/EmailDialog";
import ItineraryIncrements from "./ItineraryIncrements.vue";
import ItineraryDetailsVouchers from "./ItineraryDetailsVouchers";
import TaskTrackerList from "../plugins/task-tracker/TaskTrackerList";
import EmailsList from "../shared/EmailsList.vue";
import ExternalFormDialog from "../shared/external-forms/ExternalFormDialog.vue";
import CustomDataTypes from "../shared/custom-data-types/CustomDataTypes.vue";
import ItineraryPushNotifications from "./notifications/ItineraryPushNotifications.vue";
import RoomingList from "./rooming-list/RoomingList.vue";
const randomize = require("randomatic");
export default {
  components: {
    ItineraryDetailsContactSuppliers,
    ItineraryDetailsParticipantsList,
    ItineraryDetailsItemsList,
    ItineraryDetailsHeaderInfo,
    ItineraryDetailsDocumentsList,
    ItineraryDetailsFinancesTabs,
    SalesInvoiceList,
    PaymentList,
    PurchaseInvoiceList,
    BackToListBtn,
    ItineraryRoutes,
    BasicComponentsList,
    ItineraryDetailsSettings,
    Contents,
    ServiceGroups,
    ItineraryDetailsLogs,
    EmailDialog,
    ItineraryIncrements,
    TaskTrackerList,
    ItineraryDetailsVouchers,
    EmailsList,
    ExternalFormDialog,
    CustomDataTypes,
    ItineraryPushNotifications,
    RoomingList,
  },
  data() {
    return {
      id: this.$route.params.id,
      debug: false,
      boxes: boxes,
      charts: charts,
      selectedTab: 0,
      itinerary: {
        edges: [],
        pax: { adults: 0, children: 0, infants: 0 },
        createdBy: { name: "" },
        items: { edges: [] },
        participants: { edges: [] },
        documents: { edges: [] },
      },
      routes: [],
      serviceGroups: [],
      context: "itinerary",
      customFilters: {
        itinerary_id: this.$route.params.id,
      },
      model: "tab-1",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      salesInvoiceSkip: true,
      boxesSettings: this.$store.getters.localSettings(
        "itDetailsBoxesSettings",
        {
          visibleItems: ["Agent", "Reference", "Booking Status"],
          coumns: 3,
        }
      ),
      chartsSettings: this.$store.getters.localSettings(
        "itDetailsChartsSettings",
        {
          visibleItems: [
            "Profitability",
            "Markup by Supplier",
            "Profit by Supplier",
          ],
          coumns: 3,
        }
      ),
      tabs: this.$store.getters.localSettings("itDetailsTabs", [
        "details",
        "items",
        "participants",
        "documents",
        "tasks",
        "roomingList",
      ]),
      showEmailDialog: false,
      email: null,
      selectedForm: null,
      showFormDetails: false,
      emailDialogKey: Math.random(),
    };
  },

  computed: {
    showItemsTabFirst() {
      return this.$store.getters.hasAccessTo("itineraries:details_items_first");
    },
    participants() {
      return this.itinerary && this.itinerary.participants
        ? this.itinerary.participants.edges.map(removeGQLTypename).map((p) => ({
            id: p.client ? p.client.id : randomize("Aa0", 32),
            ...p,
          }))
        : [];
    },
    logs() {
      return this.itinerary && this.itinerary.logs
        ? this.itinerary.logs.edges.map(removeGQLTypename)
        : [];
    },
    featuredImage() {
      //return "https://www.pixelstalk.net/wp-content/uploads/2016/06/Hawaii-Wallpapers-HD-Free-Download.jpg";
      if (this.itinerary && this.itinerary.featuredImage != "") {
        return this.itinerary.featuredImage;
      } else {
        //just for now
        return "https://www.pixelstalk.net/wp-content/uploads/2016/06/Hawaii-Wallpapers-HD-Free-Download.jpg";
      }
    },
    visibleTabs() {
      return this.$store.getters.localSettings("itDetailsTabs")
        ? [...this.$store.getters.localSettings("itDetailsTabs")]
        : [];
    },
    items() {
      //prepare for service groups
      return this.itinerary && this.itinerary.items.edges
        ? this.itinerary.items.edges.map(removeGQLTypename).map((item) => ({
            ...item,
            adults: item.pax.adults,
            children: item.pax.children,
            infants: item.pax.infants,
            price: item.totalPrice,
            serviceAltName: item.service ? item.service.altName : "",
          }))
        : [];
    },
  },

  methods: {
    reloadItinerary() {
      console.log("reloading itinerary");
      this.$apollo.queries.itinerary.refetch();
    },
    onFormDetails(payload) {
      this.selectedForm = { ...payload };
      this.showFormDetails = true;
      console.log("showing form details", payload);
    },
    onSendMessage(payload) {
      this.$apollo
        .mutate({
          mutation: SEND_CLIENT_MESSAGE,
          variables: { input: { ...payload, itineraryId: this.id } },
        })
        .then((res) => {
          if (res.data.contactClient.success) {
            this.$store.dispatch("showAppSnackbar", {
              msg: "Message Sent",
            });
            this.showEmailDialog = false;
          } else {
            //res.data.ContactClient.success
            this.$store.dispatch("showAppSnackbar", {
              msg: res.data.contactClient.error,
              color: "error",
            });
          }
        })
        .catch((err) => {
          //console.log(err);
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
          console.log(err);
        });
    },
    showEmailPopUp() {
      this.emailDialogKey = Math.random();
      this.showEmailDialog = true;
    },
    onContactClient(payload) {
      const recipients = this.itinerary.participants.edges
        .filter((p) => p.node.email != "")
        .map((p) => ({
          value: p.node.email,
          label: `${p.node.name} ${p.node.surname} (${p.node.email})`,
        }));
      this.email = {
        emailTo: recipients[0],
        ccTo: this.$store.getters.userEmail,
        message: payload ? payload.message : "",
        shareLink: payload ? payload.shareLink : "",
        multiple: true,
        recipients: [recipients.shift(), ...recipients.sort(sortBy("value"))],
        emailToLabel: "Client",
      };
      this.showEmailPopUp();
    },
    onContactAgent(payload) {
      this.email = {
        emailTo: this.itinerary.agent.email,
        ccTo: this.$store.getters.userEmail,
        message: payload ? payload.message : "",
        shareLink: payload ? payload.shareLink : "",
      };
      this.showEmailPopUp();
    },
    onContactSupplier() {
      this.email = {
        emailTo: "",
        emailToLabel: "Supplier",
        recipients: this.itinerary.items.edges
          .filter(
            (item) =>
              item.node.supplier &&
              (item.node.supplier.email != "" ||
                item.node.supplier.accountsEmail != "")
          )
          .reduce((emails, item) => {
            if (item.node.supplier.email != "") {
              emails.push({
                label: `${item.node.supplierName} (Default: ${item.node.supplier.email})`,
                value: item.node.supplier.email,
              });
            }
            if (item.node.supplier.accountsEmail != "") {
              emails.push({
                label: `${item.node.supplierName} (Accounts: ${item.node.supplier.accountsEmail})`,
                value: item.node.supplier.accountsEmail,
              });
            }
            return emails;
          }, []),
        ccTo: this.$store.getters.userEmail,
        message: "",
        multiple: true,
      };
      this.showEmailDialog = true;
    },
    onServiceGroupsSave() {
      this.$apollo
        .mutate({
          mutation: UPDATE_ITI_HEADER,
          variables: {
            id: this.itinerary.id,
            input: {
              serviceGroups: this.serviceGroups.map((s) => {
                //remove totalPrice from service groups
                if (s.hasOwnProperty("totalPrice")) {
                  const { totalPrice, ...item } = s;
                  return item;
                } else {
                  return s;
                }
              }),
            },
          },
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Changes Saved.",
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: err,
            color: "warning",
          });
        });
    },
    onBoxesSettingsChange(payload) {
      this.$store.dispatch("updateLocalSettings", {
        itDetailsBoxesSettings: { ...payload },
      });
    },
    onChartsSettingsChange(payload) {
      this.$store.dispatch("updateLocalSettings", {
        itDetailsChartsSettings: { ...payload },
      });
    },
    onSettingsChange(payload) {
      this.$store.dispatch("updateLocalSettings", {
        itDetailsTabs: [...payload],
      });
    },
    checkRouter() {
      //console.log(this.$route.name);
    },
    backToList() {
      this.$router.go(-1);
    },
    onEdit() {
      this.$router.push("/itinerary/" + this.id + "/edit");
    },
    onMessage(message) {
      this.$store.dispatch("showAppSnackbar", {
        msg: message.resultMessage,
        color: message.resultMessageColor,
      });
    },
    tabIsVisible(key) {
      return this.visibleTabs.indexOf(key) > -1;
    },
    serviceGroupsMap(sg) {
      return {
        id: sg.node.id,
        name: sg.node.name,
        description: sg.node.description,
        items: sg.node.items.edges.map(removeGQLTypename),
        participants: sg.node.participants.edges.map(removeGQLTypename),
        totalPrice: 0,
      };
    },
  },

  apollo: {
    itinerary: {
      query: ITINERARY_RECORD,
      variables() {
        return {
          id: this.id,
        };
      },
      fetchPolicy: "network-only",
      result({ data }) {
        this.routes = data.itinerary.routes.edges
          ? [...data.itinerary.routes.edges.map(removeGQLTypename)]
          : [];
        this.serviceGroups = data.itinerary.serviceGroups.edges.map(
          this.serviceGroupsMap
        );
        this.$store.dispatch(
          "setAppToolbarInfo",
          `Ref: ${
            this.itinerary.reference.split("/")[2]
          }, From: ${this.$options.filters.formatDate(
            this.itinerary.startDate
          )}, Agent: ${this.itinerary.agentName}, Client: ${
            this.itinerary.clientName
          }, Destination: ${this.itinerary.destinationName}, Status: ${
            this.itinerary.internalStatus
          } (${this.itinerary.bookingStatus})`
        );
        document.title = `${
          this.itinerary.reference.split("/")[2]
        } | Details | VueTrip`;
      },
    },
  },
  beforeDestroy() {
    this.$store.dispatch("setAppToolbarInfo", "");
    document.title = "VueTrip";
  },
  mounted() {
    if (this.$route.query.tab) {
      this.selectedTab = parseInt(this.$route.query.tab);
    }
    //console.log("selectedTab", this.selectedTab);
  },
};
</script>
<style scoped>
.bg {
  background: #f4f7fd;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetails.vue